export const DICT_VESSEL = {
  custom: {
    owner_name: {
      required: "กรุณากรอก ชื่อผู้ควบคุมเรือ / ไต๋เรือ / ผู้ทำการประมง",
      alpha: "Your first name may only contain alphabetic characters",
    },
    card_number: {
      required: "กรุณากรอก เลขบัตรประชาชน",
      // alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ 13 หลัก"
    },
    vessel_name: {
      required: "กรุณากรอก ชื่อเรือ",
      alpha: "Your last name may only contain alphabetic characters",
    },
    vessel_purpose: {
      required: "กรุณากรอก วัตถุประสงค์ในการใช้เรือ",
      alpha: "Your last name may only contain alphabetic characters",
    },
    registration_number: {
      required: "กรุณากรอก หมายเลขทะเบียนเรือ",
      alpha: "Your last name may only contain alphabetic characters",
      min: "กรุณากรอกข้อมูลให้ครบ 9 หลัก"
    },
    port_name: {
      required: "กรุณากรอก เมืองท่าที่ขึ้นทะเบียนเรือ",
      alpha: "Your last name may only contain alphabetic characters",
    },
    sub_name: {
      required: "กรุณากรอก ชื่อเรียกขาน",
      alpha: "Your last name may only contain alphabetic characters",
    },
    material: {
      required: "กรุณากรอก วัสดุตัวเรือ",
      alpha: "Your last name may only contain alphabetic characters",
    },
    size: {
      required: "กรุณากรอก ขนาดเรือ ความยาวตลอดลำเมตร",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    width: {
      required: "กรุณากรอก ความกว้าง",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    depth: {
      required: "กรุณากรอก ความลึก",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    ton_gross: {
      required: "กรุณากรอก ตันกรอส",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    ton_net: {
      required: "กรุณากรอก ตันเนต",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    machine_type: {
      required: "กรุณากรอก ชนิดเครื่องจักร",
      alpha: "Your last name may only contain alphabetic characters",
    },
    machine_name: {
      required: "กรุณากรอก ชื่อเครื่อง",
      alpha: "Your last name may only contain alphabetic characters",
    },
    machine_number: {
      required: "กรุณากรอก จำนวนเครื่อง",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    engine_number: {
      required: "กรุณากรอก จำนวนสูบ",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    engine_size: {
      required: "กรุณากรอก ขนาดเครื่องยนต์",
      alpha: "Your last name may only contain alphabetic characters",
    },
    capacity: {
      required: "กรุณากรอก ปริมาตรความจุถังน้ำมัน ( ใช้สำหรับเรือ )",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    capacity_forsale: {
      required: "กรุณากรอก ปริมาตรความจุถังบรรทุกน้ำมัน ( กรณีเรือบรรทุกน้ำมัน / เรือสถานีบริการจำหน่ายน้ำมัน )",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
    },
    vessel_type: {
      required: "กรุณากรอก ประเภทเรือ",
      alpha: "Your last name may only contain alphabetic characters",
    },
    usage_type: {
      required: "กรุณากรอก ประเภทการใช้",
      alpha: "Your last name may only contain alphabetic characters",
    },
    certificate_date: {
      required: "กรุณากรอก ใบอนุญาตใช้เรือจดทะเบียนล่าสุดวันที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    expire_date: {
      required: "กรุณากรอก หมดอายุวันที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    license_number: {
      required: "กรุณากรอก หมายเลขอาชญาบัตร / ใบอนุญาตทำการประมง",
      alpha: "Your last name may only contain alphabetic characters",
      min: "กรุณากรอกข้อมูลให้ครบ 12 หลัก"
    },
    tool_type: {
      required: "กรุณากรอก ประเภทเครื่องมือทำการประมง",
      alpha: "Your last name may only contain alphabetic characters",
    },
    expireDate: {
      required: "กรุณากรอก หมดอายุวันที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    vessel_image: {
      required: "กรุณาอัปโหลดรูปชื่อเรือ / เลขทะเบียนเรือ",
    },
    right_vessel_image: {
      required: "กรุณาอัปโหลดรูปเรือทั้งลำ (ด้านข้างขวา)",
    },
    left_vessel_image: {
      required: "กรุณาอัปโหลดรูปเรือทั้งลำ (ด้านข้างซ้าย)",
    },
    AIS_image: {
      required: "กรุณาอัปโหลดรูปจุดที่จะขอติดตั้งอุปกรณ์ระบบ AIS",
    },
    measuring_system_image: {
      required: "กรุณาอัปโหลดรูปจุดที่จะขอติดตั้งระบบมาตรวัด",
    },
    receiveOil_code: {
      required: "กรุณากรอก รหัสรับน้ำมัน",
      min: "กรุณากรอกข้อมูลให้ครบ 8 หลัก"
    },
    license_expire_date: {
      required: "กรุณากรอก หมดอายุวันที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    files: {
      required: "กรุณาอัปโหลดเอกสาร เพื่อเป็นหลักฐานยืนยัน",
    },
    registration_excise:{ 
      required: "กรุณากรอก เลขทะเบียนเรือสรรพสามิต",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ 10 หลัก"
    },
    fisheries_license:{
      min: "กรุณากรอกข้อมูลให้ครบ 12 หลัก"
    }

  }
};

export const DICT_USER = {
  custom: {
    cardnumber_image:{ 
      required: "กรุณาอัปโหลดรูปบัตรประชาชน",
    },
    title:{ 
      required: "กรุณากรอก คำนำหน้า",
      alpha: "Your first name may only contain alphabetic characters",
    },
    first_name: {
      required: "กรุณากรอก ชื่อ",
      alpha: "Your first name may only contain alphabetic characters",
    },
    last_name: {
      required: "กรุณากรอก นามสกุล",
      alpha: "Your last name may only contain alphabetic characters",
    },
    card_number: {
      required: "กรุณากรอก หมายเลขประจำตัวประชาชน",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ 13 หลัก"
    },
    registration_excise:{ 
      required: "กรุณากรอก เลขทะเบียนเรือสรรพสามิต",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ 10 หลัก"
    },
    house_code_number: {
      required: "กรุณากรอก เลขรหัสประจำบ้าน",
      alpha: "Your last name may only contain alphabetic characters",
    },
    village_number: {
      required: "กรุณากรอก หมู่ที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    registration_office: { 
      required: "กรุณากรอก ที่ตั้งสำนักงานใหญ่เลขที่",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      alpha: "Your last name may only contain alphabetic characters",
    },
    building_name:{ 
      required: "กรุณากรอก ชื่ออาคาร",
      alpha: "Your last name may only contain alphabetic characters",
    },
    address:{ 
      required: "กรุณากรอก เลขที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    floor:{ 
      required: "กรุณากรอก ชั้นที่",
      alpha: "Your last name may only contain alphabetic characters",
    },
    lane: {
      required: "กรุณากรอก ตรอก/ซอย",
      alpha: "Your last name may only contain alphabetic characters",
    },
    road: {
      required: "กรุณากรอก ถนน",
      alpha: "Your last name may only contain alphabetic characters",
    },
    province: {
      required: "กรุณากรอก จังหวัด",
      alpha: "Your last name may only contain alphabetic characters",
    },
    district: {
      required: "กรุณากรอก อำเภอ/เขต",
      alpha: "Your last name may only contain alphabetic characters",
    },
    sub_district: {
      required: "กรุณากรอก ตำบล/ซอย",
      alpha: "Your last name may only contain alphabetic characters",
    },
    postal_code: {
      required: "กรุณากรอก หมายเลขรหัสไปรษณีย์",
      alpha: "Your last name may only contain alphabetic characters",
    },
    phone_number: {
      required: "กรุณากรอก เบอร์โทรศัพท์",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ 9 หรือ 10 หลัก"
    },
    email: {
      required: "กรุณากรอก อีเมล",
      alpha: "Your last name may only contain alphabetic characters",
      email: "กรอกเป็นอีเมลเท่านั้น",
    },
    username: {
      required: "กรุณากรอก ชื่อผู้ใช้งาน",
      alpha: "Your last name may only contain alphabetic characters",
    },
    password: {
      required: "กรุณากรอก รหัสผ่าน",
      alpha: "Your last name may only contain alphabetic characters",
      min: "กรุณากรอกข้อมูลอย่างน้อย 8 หลัก"
    },
    confirm_password: {
      required: "กรุณากรอก ยืนยันรหัสผ่าน",
      alpha: "Your last name may only contain alphabetic characters",
      min: "กรุณากรอกข้อมูลอย่างน้อย 8 หลัก"
    },
    certificate_operate_name:{ 
      required: "กรุณากรอก ชื่อผู้ประกอบการ",
    },
    certificate_juristic_number:{ 
      required: "กรุณากรอก ทะเบียนนิติบุคคลเลขที่",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ 13 หลัก"
    },
    certificate_establishment_name:{ 
      required: "กรุณากรอก ชื่อสถานประกอบการ",
    },
    certificate_village_number:{ 
      required: "กรุณากรอก หมู่ที่",
    },
    certificate_lane:{ 
      required: "กรุณากรอก ตรอก/ซอย",
    },
    certificate_road:{ 
      required: "กรุณากรอก ถนน",
    },
    certificate_province:{ 
      required: "กรุณากรอก จังหวัด",
    },
    certificate_district:{ 
      required: "กรุณากรอก อำเภอ/เขต",
    },
    certificate_sub_district:{ 
      required: "กรุณากรอก ตำบล/แขวง",
    },
    certificate_postal_code:{ 
      required: "กรุณากรอก รหัสไปรษณีย์",
    },
    certificate_phone_number:{ 
      required: "กรุณากรอก เบอร์โทรศัพท์",
      alpha: "Your last name may only contain alphabetic characters",
      numeric: "กรอกเป็นตัวเลขเท่านั้น",
      min: "กรุณากรอกข้อมูลให้ครบ  9 หรือ 10 หลัก"
    },
    certificate_email:{ 
      required: "กรุณากรอก อีเมล",
      alpha: "Your last name may only contain alphabetic characters",
      email: "กรอกเป็นอีเมลเท่านั้น",
    },
    partnerships_image:{ 
      required: "กรุณาอัปโหลดรูปใบสำคัญแสดงการจดทะเบียนห้างหุ้นส่วนบริษัท",
    },
    certificate_image:{ 
      required: "กรุณาอัปโหลดรูปหนังสือรับรอง",
    },
  },
};

export const INSTALL_ACCESSOIRES = {
  custom: {
    vessel_image: {
      required: "กรุณาอัปโหลดรูปชื่อเรือ / เลขทะเบียนเรือ",
    },
    right_vessel_image: {
      required: "กรุณาอัปโหลดรูปเรือทั้งลำ (ด้านข้างขวา)",
    },
    left_vessel_image: {
      required: "กรุณาอัปโหลดรูปเรือทั้งลำ (ด้านข้างซ้าย)",
    },
    GPS_image: {
      required: "กรุณาอัปโหลดรูปอุปกรณ์ GPS Antenna",
    },
    VHF_image: {
      required: "กรุณาอัปโหลดรูปอุปกรณ์ VHF Antenna",
    },
    AIS_image: {
      required: "กรุณาอัปโหลดรูปอุปกรณ์ AIS Device",
    },
    measuring_system_image: {
      required: "กรุณาอัปโหลดรูปจุดที่จะขอติดตั้งระบบมาตรวัด",
    },
    files: {
      required: "กรุณาอัปโหลดเอกสาร เพื่อเป็นหลักฐานยืนยัน",
    },
  }
}


